import router from "./router/router";
import store from "./store/store";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken, setToken, setLoginUser } from "@/utils/auth"; // getToken from cookie
import { generateIndexRouter, getQueryVariable } from "@/utils/utils";
import { loadAreaData } from "@/utils/area";
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

const whiteList = [
  "/login",
  "/wxlogin",
  "/individualRanking",
  "/overseasGoodsDetail"
]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  if (
    to.name &&
    to.name !== "login" &&
    to.name !== "individualRanking" &&
    to.name !== "wxlogin" &&
    to.name !== "overseasGoodsDetail" &&
    !to.meta.tab
  ) {
    if (to.name !== "") {
      let funcId = {
        name: to.name,
        title: to.meta.title
      };
      let params = {
        moduleType: "tab",
        funcType: "recentlyUsedTabs",
        funcId: JSON.stringify(funcId)
      };
      store.dispatch("sysPersonalizedRecentUsageRecord", params);
    }
  }
  if (to.meta.title) {
    // 如果设置标题，拦截后设置标题
    document.title = to.meta.title;
  }
  NProgress.start(); // start progress bar

  // 异常登录流程
  const linkToken = getQueryVariable("token");
  const username = getQueryVariable("username");
  if (to.path.indexOf("login") > -1 && linkToken) {
    if (store.getters.permissionList.length === 0) {
      // Vue.prototype.$token = getToken();
      store.commit("SET_TOKEN", linkToken);
      setToken(linkToken);
      try {
        const { result } = await store.dispatch("getLoginUserInfo", {
          username: decodeURIComponent(username)
        });
        let data = {
          realname: result.realname,
          storeId: "",
          storeName: "",
          roles: ["editor"],
          userId: result.id,
          storeCode: result.storeCode,
          phone: result.phone
        };
        setLoginUser(data);
        const res = await store.dispatch("GetPermissionList");
        const menuData = res.result.menu;
        if (!menuData) {
          next();
          return;
        }
        let constRoutes = [];
        constRoutes = generateIndexRouter(menuData);
        // 添加主界面路由
        await store.dispatch("UpdateAppRouter", { constRoutes });
        // 根据roles权限生成可访问的路由表
        // 动态添加可访问路由表
        router.addRoutes(store.getters.addRouters);
        // 登录成功后加载/更新省市区 CDN 数据
        loadAreaData(store).catch(err => console.error("省市区数据加载失败", err));
        const redirect = decodeURIComponent(from.query.redirect || to.path);
        if (to.path === redirect) {
          // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
          next({ ...to, replace: true });
        } else {
          // 跳转到目的路由
          next({ path: redirect });
        }
      } catch (error) {
        await store.dispatch("LogOut");
        next({ path: "/login" });
        throw new Error(error);
      }
    } else {
      next();
    }
    return;
  }

  // 正常登录流程
  if (getToken()) {
    // determine if there has token
    /* has token*/
    if (to.path === "/login") {
      next({
        path: "/"
      });
      NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.permissionList.length === 0) {
        store
          .dispatch("GetPermissionList")
          .then(res => {
            const menuData = res.result.menu;
            if (!menuData) {
              return;
            }
            let constRoutes = [];
            constRoutes = generateIndexRouter(menuData);
            // 添加主界面路由
            store.dispatch("UpdateAppRouter", { constRoutes }).then(() => {
              // 根据roles权限生成可访问的路由表
              // 动态添加可访问路由表
              router.addRoutes(store.getters.addRouters);
              // 登录成功后加载/更新省市区 CDN 数据
              loadAreaData(store).catch(err => console.error("省市区数据加载失败", err));
              const redirect = decodeURIComponent(
                from.query.redirect || to.path
              );
              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                next({ ...to, replace: true });
              } else {
                // 跳转到目的路由
                next({ path: redirect });
              }
            });
          })
          .catch(err => {
            // 包含新页面
            if (err.message.indexOf("Cannot find module") > -1) {
              console.warn("[权限守卫] 路由组件加载失败:", err.message);
              next({ path: "/", replace: true });
              return;
            }
            store.dispatch("LogOut").then(() => {
              // next({ path: "/user/login", query: { redirect: to.fullPath } });
              next(`/login`);
            });
            throw new Error(err);
          });
      } else {
        next();
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      // next(`/login?redirect=${to.path}`); // 否则全部重定向到登录页
      next(`/login`); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});
